export default "__VITE_ASSET__yAmiK6jz__"